export default __webpack_public_path__ + "static/logo-45d9dfd1d185af1f274f3cbf66f3401f.svg";